import React from 'react';
import { Input, Select } from 'antd'
import moment from 'moment';
import DateRangePicker from 'app/components/shared/app/DateRangePicker';
import ReactJsonViewer from 'app/lib/utils/ReactJsonViewer';

const typeMap = {
    'adtrack-error': 'Tracking Error',
    'adtrack-message': 'Tracking Message',
    'client-error': 'Client Error',
    'client-message': 'Client Message',
    'server-error': 'Server Error',
    'server-message': 'Server Message'
}

export const columns = [
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        shouldUseAsfilter: true,
        name: "date",
        sorter: (a, b) => a.date.localeCompare(b.date),
        render: (d) => {return moment(d).format('M/D/YYYY @ H:M:SS A')},
        filterComponent: ({ onFilterChange, ...props }) => {
            return <DateRangePicker onDateConfirm={onFilterChange} {...props} />
        }
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        sorter: (a, b) => a.type.localeCompare(b.type),
        render: (type) => {return typeMap[type] || '(none)'},
        shouldUseAsfilter: true,
        filterComponent: ({ onChange }) => <Select style={{ width: 300 }} placeholder="Select Log Type"  onSelect={onChange}>
            {
                Object.keys(typeMap).map((value, index) => {
                    let text = typeMap[value];
                    return <Select.Option key={`select-log-type-${index}`} value={value}>{text}</Select.Option>
                })
            }
        </Select>
    },
    {
        title: 'Message',
        dataIndex: 'message',
        key: 'message',
        sorter: (a, b) => a?.message?.localeCompare(b?.message),
        shouldUseAsfilter: true
    },
    {
        title: 'Data',
        dataIndex: 'data',
        key: 'data',
        render: (data) => (
            <div className="data-item">
                <ReactJsonViewer style={{ minWidth: "525px", maxWidth: "600px" }} src={data} collapsed={true}/>
            </div>
        ),
        shouldUseAsfilter: false
    }
];

export const formSchema = [
    {
        props: {
            name: "date",
            label: "Date"
        },
        component: Input,
    },
    {
        props: {
            name: "type",
            label: "Type"
        },
        component: Input,
    },
    {
        props: {
            name: "message",
            label: "Message"
        },
        component: Input,
    }
]
